import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { API } from "./App";
import { getAuthHeader } from "./AuthRoute";

const FsAdminPage = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchFiles = () => {
    setLoading(true);
    fetch(API() + "/admin/fs/list", {
      headers: { Authorization: getAuthHeader() },
    })
      .then((res) => res.json())
      .then((data) => setFiles(data))
      .catch((err) => alert("Error: " + err.message))
      .finally(() => setLoading(false));
  };

  const deleteFile = (id) => {
    if (!window.confirm("Delete this file?")) return;
    fetch(API() + "/admin/fs/delete/" + id, {
      method: "DELETE",
      headers: { Authorization: getAuthHeader() },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to delete");
        fetchFiles();
      })
      .catch((err) => alert("Error: " + err.message));
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const deleteTemplate = (rowData) => (
    <Button
      icon="pi pi-trash"
      className="p-button-danger p-button-sm"
      onClick={() => deleteFile(rowData._id)}
    />
  );

  return (
    <div className="card">
      <h3>GridFS File Manager</h3>
      {/*delete all files button*/}
      <Button
        label="Delete All Files"
        icon="pi pi-trash"
        className="p-button-danger"
        onClick={() => {
          if (window.confirm("Are you sure you want to delete all files?")) {
            fetch(API() + "/admin/fs/delete-all", {
              method: "DELETE",
              headers: { Authorization: getAuthHeader() },
            })
              .then((res) => {
                if (!res.ok) throw new Error("Failed to delete all files");
                fetchFiles();
              })
              .catch((err) => alert("Error: " + err.message));
          }
        }}
        style={{ marginBottom: "10px" }}
      />
      <Button
        label="Delete All PDF Files"
        icon="pi pi-trash"
        className="p-button-danger"
        onClick={() => {
          if (
            window.confirm("Are you sure you want to delete all PDF files?")
          ) {
            fetch(API() + "/admin/fs/delete-all-pdf", {
              method: "DELETE",
              headers: { Authorization: getAuthHeader() },
            })
              .then((res) => {
                if (!res.ok) throw new Error("Failed to delete all PDF files");
                fetchFiles();
              })
              .catch((err) => alert("Error: " + err.message));
          }
        }}
        style={{ marginBottom: "10px" }}
      />

      <DataTable
        value={files}
        loading={loading}
        paginator
        rows={10}
        responsiveLayout="scroll"
        showGridlines
      >
        <Column field="filename" header="Filename" />
        <Column field="length" header="Size (bytes)" />
        <Column field="uploadDate" header="Uploaded" />
        <Column
          body={deleteTemplate}
          header="Delete"
          style={{ width: "100px" }}
        />
      </DataTable>
    </div>
  );
};

export default FsAdminPage;
